import { environment } from '@/environment'

/**
 * This will load the sidenav and wait for login to complete.
 * It expects the sidenav-app and script
 *
 * @returns after auth0 login completes
 */
export async function loadSidenavAndLogin() {
  loadSidenav()
  await waitForSidenavLogin()
}

/**
 * If the app already loads sidenav, this will simply wait for the login to complete
 *
 * @returns after auth0 login completes
 */
async function waitForSidenavLogin() {
  return new Promise<void>((resolve, reject) => {
    let sidenavInitCounter = 0
    if ((window as any)?.sidenav?.isAuthenticationComplete) resolve()
    else {
      window.addEventListener('cwanAuthCompleted', () => {
        resolve()
      })

      const interval = setInterval(() => {
        if (sidenavInitCounter++ > 60) {
          clearInterval(interval)
          resolve()
          // reject(
          //   new Error('Timed out waiting for sidenav init. Refresh Your Page'),
          // ) //if this happens, it could be that sidenav is not initializing FullStory in this environment (like stg)
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((window as any)?.sidenav?.isAuthenticationComplete) {
          clearInterval(interval)
          resolve()
        }
      }, 100) //check every 100ms
    }
  })
}

function loadSidenav() {
  const now = Date.now()
  const baseUrl = environment.sidenavBaseUrl
  let sidenavAppEl = document.getElementById('sidenavApp')
  let needsAppend = false
  if (!sidenavAppEl) {
    sidenavAppEl = document.createElement('div')
    sidenavAppEl.id = 'sidenavApp'
    needsAppend = true
  }

  //tell sidenav to handle the login, in addition to the auth token
  sidenavAppEl.setAttribute('isSideNavBasedLogin', 'true')

  if (needsAppend) document.body.appendChild(sidenavAppEl)

  /**
   * Sidenav source scripts
   */

  //realm config / env needs to load before main src
  const envEl = document.createElement('script')
  envEl.setAttribute('src', `${baseUrl}/env.js?v=${now}`)
  if ((window as any)?.Cypress) {
    envEl.setAttribute('crossorigin', 'anonymous')
  }
  document.body.appendChild(envEl)

  const sidenavSrcEl = document.createElement('script')
  sidenavSrcEl?.setAttribute('src', `${baseUrl}/sidenavbar.js?v=${now}`)
  if ((window as any)?.Cypress) {
    sidenavSrcEl.setAttribute('crossorigin', 'anonymous')
  }
  // sidenavSrcEl.setAttribute('crossorigin', 'anonymous')
  document.body.appendChild(sidenavSrcEl)
}
